import React, { useContext, useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { ReactComponent as CloseBtn } from '../../../../assets/icons/close.svg';
import PostLoginPostApi from '../../../../components/Api/PostLoginPostApi';
import BlackButton from '../../../../components/BlackButton';
// import init from '../../AccessControl/Check';
import $ from 'jquery';
import { SUPER_ADMIN } from "../../ConstRole/ConstRole";
import UserBasicInfoContext from '../../../../components/Context/UserBasicInfoContext';

const EditMou = () => {

    // const pageName = "Measure of unit edit";
    // const isAccess = init(pageName);


    const userProfile = useContext(UserBasicInfoContext);

    const state = useLocation();
    const navigate = useNavigate();
    const [input, setInput] = useState({
        name: ""
    });


    useEffect(() => {
        if (state?.state?.data?.id === undefined) {
            return navigate("/dashboard/category", {
                state: {
                    tab: "Mou"
                }
            });
        }

        if (state?.state?.data?.name === undefined) {
            return navigate("/dashboard/category", {
                state: {
                    tab: "Mou"
                }
            });
        }

        setInput({id: state.state.data.id, name: state.state.data.name});

    }, [navigate, state]);

    const onSubmit = (e) => {
        e.preventDefault();

        if (input?.name === "") {
            toast.error("Please enter measure of unit name.");
            return;
        }


        $("#add-voucher-category-btn").attr("disabled", true);


        PostLoginPostApi("mou/update/"+input.id, JSON.stringify({name: input.name}), 3).then((responseJSON) => {
            let response = JSON.stringify(responseJSON);
            response = JSON.parse(response);

            if (response["status"] === 1) {
                let responseData = JSON.stringify(response["data"]);
                responseData = JSON.parse(responseData);

                if (responseData["code"] === 200) {
                    toast.success("Measure of unit update successfully.");
                    navigate("/dashboard/category", {
                        state: {
                            tab: "Mou"
                        }
                    });
                    return;
                }

                toast.error(responseData["messages"].toString() + "");
                $("#add-voucher-category-btn").attr("disabled", false);
            }
        }).catch((error) => {
            console.log(error);
        });
    }

    const handleChange = (evt) => {
        const value = evt.target.value;

        setInput({
            ...input, [evt.target.name]: value
        });
    }

    
    
    if(userProfile.user_type !==  SUPER_ADMIN) {
        return (
            <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
                <table className="custom-details-table w-full mt-0 mb-2">
                    <tbody>
                        <tr>
                            <td className="font-semibold text-base">
                                You do not have any access !
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }


    return (
        <div className="font-medium min-h-[100vh] w-[100%] h-[100%] custom-container-left custom-scroll-auto">
            <header className="p-4 border-b-2 border-dark-white mb-[60px]">
                <Link to="/dashboard/category" state={{ tab: "Mou" }}><CloseBtn className="float-left" /></Link>
                <p className="text-center text-lg">Update measure of unit</p>
            </header>
            <main className="max-w-2xl m-auto">

                <form onSubmit={onSubmit} autoComplete="off">

                    <div className="relative pb-2 pt-1 mb-[15px]">
                        <input type="text" name="name" id="name" placeholder=" " value={input.name} onChange={handleChange} className="w-full rounded border-solid border border-dark-white placeholder:text-ash appearance-none dark:text-white dark:border-gray-600 dark:focus:border-blue-500 focus:outline-none focus:ring-0 focus:border-blue-600 peer" required />

                        <label htmlFor="name" className="absolute text-base text-gray-500 dark:text-gray-400 duration-300 transform -translate-y-4 scale-75 top-2 z-10 origin-[0] bg-white dark:bg-gray-900 px-2 peer-focus:px-2 peer-focus:text-blue-600 peer-focus:dark:text-blue-500 peer-placeholder-shown:scale-100 peer-placeholder-shown:-translate-y-1/2 peer-placeholder-shown:top-1/2 peer-focus:top-2 peer-focus:scale-75 peer-focus:-translate-y-4 left-1">Measure of unit name *</label>
                    </div>

                    <BlackButton id="add-voucher-category-btn" name="Update Measure of Unit" />

                </form>

            </main>
        </div>
    );
};

export default EditMou;